let swiperInitialized = false;
let lookbookTimeout = null;
let lastLookbookCount = 0;


document.addEventListener("DOMContentLoaded", function () {
  updateFooter();
  // updateBlog();
  safeUpdateLookbook();
  setupFeaturedCollections();
  moveQuickBuyElementsOutOfSwiper();

  ratingSymbols();
  insertChannels();

  const observer = new MutationObserver(() => {
    safeUpdateLookbook(); 
    setupFeaturedCollections();
    moveQuickBuyElementsOutOfSwiper();
    moveQuickViewToImageWrapperFromProductContent();

    ratingSymbols();
    insertChannels();
  });

  observer.observe(document.body, { childList: true, subtree: true });
});


function safeUpdateLookbook() {
  clearTimeout(lookbookTimeout);
  lookbookTimeout = setTimeout(() => {
    updateLookbook();
  }, 1000);
}


function updateLookbook() {
  const lookbooks = document.querySelectorAll(".lookbook-grid");

  
  // Skip update if same number of sliders as last time
  if (lookbooks.length === lastLookbookCount) return;
  lastLookbookCount = lookbooks.length;
  

  lookbooks.forEach(function (itemList) {
    const swiperContainer = itemList.querySelector(".swiper");
    if (!swiperContainer) return;
    
    itemList.classList.add("lookbook-grid-slider");
    
    const section = itemList.closest(".shopify-section");
    if (section) {
      section.classList.add("shopify-section--slider-custom");
    }

    // Destroy Swiper instance if it exists
    if (swiperContainer.swiper) {
      swiperContainer.swiper.destroy(true, true);
    }

    // Add nav buttons if not present
    if (itemList.querySelector(".swiper-button-prev")) {
      const prev = itemList.querySelector(".swiper-button-prev");
      prev.innerHTML = `<svg focusable="false" width="17" height="14" viewBox="0 0 17 14">
        <path d="M17 7H2M8 1L2 7l6 6" stroke="currentColor" stroke-width="1" fill="none"/>
      </svg>`;
    } 

    if (itemList.querySelector(".swiper-button-next")) {
      const next = itemList.querySelector(".swiper-button-next");
      next.innerHTML = `<svg focusable="false" width="17" height="14" viewBox="0 0 17 14">
        <path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="1" fill="none"/>
      </svg>`;
    }

    // Fix: use itemList to find nav buttons (they are outside swiperContainer)
    const slideButtonNext = itemList.querySelector(".swiper-button-next");
    const slideButtonPrev = itemList.querySelector(".swiper-button-prev");
    const slidePagination = itemList.querySelector(".swiper-pagination");

    // Init new Swiper instance
    const swiper = new Swiper(swiperContainer, {
      resistanceRatio: 0,
      spaceBetween: 0,
      grabCursor: true,
      pagination: {
        el: slidePagination,
        type: "bullets",
        clickable: true,
      },
      navigation: {
        nextEl: slideButtonNext,
        prevEl: slideButtonPrev,
      },
      effect: "slide",
      loop: false,
      speed: 1000,
      slidesPerView: "auto",
      centeredSlides: false,
      centerInsufficientSlides: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
    });

    swiperContainer.classList.add("swiper-initialized");

  });
}


function updateFooter() {
  const footerCopyright = document.querySelector(".footer__copyright");
  if (footerCopyright) {
    footerCopyright.innerHTML =
      '<span class="copyright">©Copyright 2025 AIIZ. All Rights Reserved</span> <span class="webby">Web by <a href="https://plaimanas.com/" target="_blank">::*</a></span>';
  }

  // Height
  const html = document.documentElement;
  const footer = document.querySelector(".shopify-section--footer");
  if (!footer) return;

  const setVar = () => {
      const h = footer.offsetHeight;
      html.style.setProperty("--footer-height", `${h}px`);
  };

  setVar();

  if (footer.dataset.footerHeightWired === "1") return;
  footer.dataset.footerHeightWired = "1";

  let rafId = null;
  const onResize = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
          rafId = null;
          setVar();
      });
  };
  window.addEventListener("resize", onResize);

  if (typeof ResizeObserver !== "undefined") {
      const ro = new ResizeObserver(onResize);
      ro.observe(footer);
      footer.__footerResizeObserver = ro;
  }
}


function updateBlog() {
  const link = document.querySelector('.link-bar__link');
  if (link && link.textContent.trim() === 'All posts') {
    link.textContent = 'All blogs';
  }
}


function setupFeaturedCollections() {
  document.querySelectorAll("*:is(.featured-collections, .shopify-section--product-recommendations) .product-list").forEach(function (itemList) {
    const hasScroller = itemList.querySelector(".scroller");
    if (!hasScroller || itemList.classList.contains("product-list-slider")) return;

    itemList.classList.add("product-list-slider");

    const scroller = Array.from(itemList.children).find((child) =>
      child.classList.contains("scroller")
    );
    if (scroller) {
      scroller.classList.add("swiper", "auto", "fix");

      const wrapper = scroller.querySelector(".product-list__inner");
      if (wrapper) {
        wrapper.classList.add("swiper-wrapper");
        wrapper.querySelectorAll(".product-item").forEach((item) => item.classList.add("swiper-slide"));
      }

      if (!itemList.querySelector(".swiper-button-prev")) {
        const prev = document.createElement("div");
        prev.classList.add("swiper-button-prev");
        prev.innerHTML = `<svg focusable="false" width="17" height="14" viewBox="0 0 17 14"><path d="M17 7H2M8 1L2 7l6 6" stroke="currentColor" stroke-width="1" fill="none"/></svg>`;
        scroller.insertAdjacentElement("afterend", prev);
      }

      if (!itemList.querySelector(".swiper-button-next")) {
        const next = document.createElement("div");
        next.classList.add("swiper-button-next");
        next.innerHTML = `<svg focusable="false" width="17" height="14" viewBox="0 0 17 14"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="1" fill="none"/></svg>`;
        scroller.insertAdjacentElement("afterend", next);
      }
    }
  });
  
  // === List Collections ===
  document.querySelectorAll(".list-collections--carousel").forEach(function (itemList) {
    if (itemList.classList.contains("list-collections-slider")) return;
    itemList.classList.add("list-collections-slider");

    const scroller = Array.from(itemList.children).find((child) =>
      child.classList.contains("list-collections__scroller")
    );

    if (scroller) {
      scroller.classList.add("swiper", "auto", "fix");

      const wrapper = scroller.querySelector(".list-collections__item-list");
      if (wrapper) {
        wrapper.classList.add("swiper-wrapper");

        wrapper.querySelectorAll(".list-collections__item").forEach(function (item) {
          const slide = document.createElement("div");
          slide.classList.add("swiper-slide");
          item.parentNode.insertBefore(slide, item);
          slide.appendChild(item);
        });
      }

      if (!itemList.querySelector(".swiper-button-prev")) {
        const prev = document.createElement("div");
        prev.classList.add("swiper-button-prev");
        prev.innerHTML = `<svg focusable="false" width="17" height="14" viewBox="0 0 17 14"><path d="M17 7H2M8 1L2 7l6 6" stroke="currentColor" stroke-width="1" fill="none"/></svg>`;
        scroller.insertAdjacentElement("afterend", prev);
      }

      if (!itemList.querySelector(".swiper-button-next")) {
        const next = document.createElement("div");
        next.classList.add("swiper-button-next");
        next.innerHTML = `<svg focusable="false" width="17" height="14" viewBox="0 0 17 14"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="1" fill="none"/></svg>`;
        scroller.insertAdjacentElement("afterend", next);
      }
    }
  });

  // === Blog Posts ===
  document.querySelectorAll(".shopify-section:is(.shopify-section--blog-posts, .shopify-section--blog-post-prev-next) .scroller")
    .forEach(function (itemList) {
      if (itemList.classList.contains("blog-posts-slider")) return;
      itemList.classList.add("blog-posts-slider");

      const scroller = Array.from(itemList.children).find((child) =>
        child.classList.contains("scroller__inner")
      );

      if (scroller) {
        scroller.classList.add("swiper", "auto", "fix");

        const wrapper = scroller.querySelector(".article-list.article-list--scrollable");
        if (wrapper) {
          wrapper.classList.add("swiper-wrapper");

          wrapper.querySelectorAll(".article-item").forEach((item) => {
            const slide = document.createElement("div");
            slide.classList.add("swiper-slide");
            item.parentNode.insertBefore(slide, item);
            slide.appendChild(item);
          });
        }

        if (!itemList.querySelector(".swiper-button-prev")) {
          const prev = document.createElement("div");
          prev.classList.add("swiper-button-prev");
          prev.innerHTML = `<svg focusable="false" width="17" height="14" viewBox="0 0 17 14"><path d="M17 7H2M8 1L2 7l6 6" stroke="currentColor" stroke-width="1" fill="none"/></svg>`;
          scroller.insertAdjacentElement("afterend", prev);
        }

        if (!itemList.querySelector(".swiper-button-next")) {
          const next = document.createElement("div");
          next.classList.add("swiper-button-next");
          next.innerHTML = `<svg focusable="false" width="17" height="14" viewBox="0 0 17 14"><path d="M0 7h15M9 1l6 6-6 6" stroke="currentColor" stroke-width="1" fill="none"/></svg>`;
          scroller.insertAdjacentElement("afterend", next);
        }
      }
    });

  // === Multi Column ===
  document.querySelectorAll(".multi-column").forEach(function (itemList) {
    if (itemList.classList.contains("multi-column-slider")) return;
    itemList.classList.add("multi-column-slider");

    const scroller = Array.from(itemList.children).find((child) =>
      child.classList.contains("scroller")
    );

    if (scroller) {
      scroller.classList.add("swiper", "auto");

      const wrapper = scroller.querySelector(".multi-column__inner");
      if (wrapper) {
        wrapper.classList.add("swiper-wrapper");

        wrapper.querySelectorAll(".multi-column__item").forEach((item) => {
          const slide = document.createElement("div");
          slide.classList.add("swiper-slide");
          item.parentNode.insertBefore(slide, item);
          slide.appendChild(item);
        });
      }

      if (!itemList.querySelector(".swiper-pagination")) {
        const pages = document.createElement("div");
        pages.classList.add("swiper-pagination");
        scroller.insertAdjacentElement("afterend", pages);
      }
    }
  });

  // === Text With Icons ===
  document.querySelectorAll("native-carousel.text-with-icons").forEach(function (itemList) {
    if (itemList.classList.contains("text-with-icons-slider")) return;
    itemList.classList.add("text-with-icons-slider");

    const scroller = Array.from(itemList.children).find((child) =>
      child.classList.contains("text-with-icons__list")
    );

    if (scroller) {
      scroller.classList.add("swiper", "auto");

      let wrapper = scroller.querySelector(".multi-column__inner");

      if (!wrapper) {
        wrapper = document.createElement("div");
        wrapper.classList.add("swiper-wrapper");

        const items = Array.from(scroller.querySelectorAll(".text-with-icons__item"));
        items.forEach((item) => {
          const slide = document.createElement("div");
          slide.classList.add("swiper-slide");
          slide.appendChild(item);
          wrapper.appendChild(slide);
        });

        scroller.innerHTML = '';
        scroller.appendChild(wrapper);
      }

      if (!itemList.querySelector(".swiper-pagination")) {
        const pages = document.createElement("div");
        pages.classList.add("swiper-pagination");
        scroller.insertAdjacentElement("afterend", pages);
      }
    }
  });

  // ✅ Call Swiper init once DOM is stable
  if (!swiperInitialized) {
    swiperInitialized = true;
    requestAnimationFrame(() => {
      setTimeout(() => {
        initAutoSwipers();
      }, 1000);
    });
  }
  
}


function moveQuickBuyElementsOutOfSwiper() {
  document.querySelectorAll(".swiper.auto").forEach((swiperEl) => {
    const parent = swiperEl.parentElement;
    swiperEl.querySelectorAll("quick-buy-popover, quick-buy-drawer").forEach((el) => {
      parent.appendChild(el);
    });
  });
}


function moveQuickViewToImageWrapperFromProductContent() {
  document.querySelectorAll(".product-content__featured-products .product-item").forEach((item) => {
    const imageWrapper = item.querySelector(".product-item__image-wrapper");
    const ctaWrapper = item.querySelector(".product-item__cta-wrapper");
    const productList = item.closest(".product-content__featured-products-list");

    if (!imageWrapper || !ctaWrapper || !productList) return;

    if (imageWrapper.querySelector(".product-item__quick-form")) return;

    const quickForm = document.createElement("div");
    quickForm.className = "product-item__quick-form";
    imageWrapper.appendChild(quickForm);

    const quickViewBtn = ctaWrapper.querySelector("button[is='toggle-button'].hidden-phone");
    if (quickViewBtn) {
      quickViewBtn.className = "button button--outline button--full hidden-touch hidden-phone moved-quick-view";
      quickViewBtn.innerHTML = `
        <span class="loader-button__text">Quick view</span>
        <span class="loader-button__loader" hidden>
          <div class="spinner">
            <svg focusable="false" width="24" height="24" class="icon icon--spinner" viewBox="25 25 50 50">
              <circle cx="50" cy="50" r="20" fill="none" stroke="currentColor" stroke-width="5"></circle>
            </svg>
          </div>
        </span>
      `;
      
      quickForm.appendChild(quickViewBtn);

      // Handle loading state manually
      quickViewBtn.addEventListener("click", () => {
        const text = quickViewBtn.querySelector(".loader-button__text");
        const loader = quickViewBtn.querySelector(".loader-button__loader");
      
        if (loader) loader.hidden = false;
        quickViewBtn.setAttribute("aria-busy", "true");
      
        setTimeout(() => {
          quickViewBtn.removeAttribute("aria-busy");
          if (loader) loader.hidden = true;
        }, 1000);
      });
    }

    const quickViewBtnMobile = ctaWrapper.querySelector("button[is='toggle-button'].hidden-tablet-and-up");
    if (quickViewBtnMobile) {
      quickViewBtnMobile.className = "product-item__quick-buy-button hidden-tablet-and-up";
      quickViewBtnMobile.innerHTML = `
        <span class="visually-hidden">Quick view</span>
        <svg focusable="false" width="24" height="24" class="icon icon--quick-buy-shopping-bag" fill="none" viewBox="0 0 24 24">
          <path d="M14 4H5L4 20H20C19.7517 16.0273 19.375 10 19.375 10" stroke="currentColor" stroke-width="1"></path>
          <path d="M9 7V7C9 8.65685 10.3431 10 12 10V10C13.6569 10 15 8.65685 15 7V7" stroke="currentColor" stroke-width="1"></path>
          <path d="M20 0V8M16 4H24" stroke="currentColor" stroke-width="1"></path>
        </svg>
      `;
      
      quickForm.appendChild(quickViewBtnMobile);

      // ✅ Trigger loading bar manually
      quickViewBtnMobile.addEventListener("click", () => {
        const loadingBar = document.querySelector("loading-bar");
        if (!loadingBar) return;
    
        // Reset state
        loadingBar.className = "loading-bar";
        loadingBar.style.transform = "scaleX(0)";
        
        // Phase 1: show and start loading
        requestAnimationFrame(() => {
          loadingBar.classList.add("is-visible");
          loadingBar.style.transform = "scaleX(0.4)";
    
          // Phase 2: finish loading
          setTimeout(() => {
            loadingBar.classList.add("is-finished");
            loadingBar.style.transform = "scaleX(1)";
    
            // Phase 3: remove after finish
            setTimeout(() => {
              loadingBar.className = "loading-bar";
              loadingBar.style.transform = "scaleX(0)";
            }, 300); // finish delay
          }, 500); // simulate loading delay
        });
      });
    }

    // Move quick-buy elements out
    ctaWrapper.querySelectorAll("quick-buy-popover, quick-buy-drawer").forEach((el) => {
      productList.parentElement.appendChild(el);
    });

    if (ctaWrapper.children.length === 0) {
      ctaWrapper.remove();
    }
  });
}


function handleFixY(swiperEl, parentEl) {
  const objectEl = swiperEl.querySelector("[class*='image-wrapper']");
  if (!objectEl) return;

  const updateY = () => {
    if (!parentEl || parentEl.offsetParent === null) return;
    const height = objectEl.offsetHeight / 2;
    parentEl.style.setProperty("--swiper-button-y", `${height}px`);
  };

  updateY();
  window.addEventListener("resize", updateY);
  const observer = new MutationObserver(updateY);
  observer.observe(parentEl, { attributes: true, attributeFilter: ["style", "class"] });
}


function initAutoSwipers() {
  const swiperAutoEls = document.querySelectorAll(".swiper.auto:not(.swiper-initialized)");
  swiperAutoEls.forEach((swiperEl) => {
    const speed = swiperEl.dataset.speed ? parseInt(swiperEl.dataset.speed) : 1000;
    const parentEl = swiperEl.closest('[class*="-slider"], [data-layout*="slider"]');

    const slideButtonNext = swiperEl.querySelector(".swiper-button-next") || parentEl?.querySelector(".swiper-button-next");
    const slideButtonPrev = swiperEl.querySelector(".swiper-button-prev") || parentEl?.querySelector(".swiper-button-prev");
    const slidePagination = swiperEl.querySelector(".swiper-pagination") || parentEl?.querySelector(".swiper-pagination");
    const slideAutoplay = swiperEl.classList.contains("autoplay");

    const swiper = new Swiper(swiperEl, {
      resistanceRatio: 0,
      spaceBetween: 0,
      grabCursor: true,
      pagination: {
        el: slidePagination,
        type: "bullets",
        clickable: true,
      },
      navigation: {
        nextEl: slideButtonNext,
        prevEl: slideButtonPrev,
      },
      effect: "slide",
      loop: false,
      speed: speed,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      slidesPerView: "auto",
      centeredSlides: false,
      centerInsufficientSlides: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      init: false,
    });

    setTimeout(() => {
      swiper.init();
      swiper.autoplay.stop();
      if (slideAutoplay) swiper.autoplay.start();
    }, 100);

    if (swiperEl.classList.contains("fix")) {
      handleFixY(swiperEl, parentEl);
    }

    swiperEl.classList.add("swiper-initialized"); // ✅ prevent re-init
  });
}


function ratingSymbols() {
  const svg = document.getElementById("oke-star-symbols");
  if (!svg) return;

  const newPath = "M7 0L8.6458 4.73475L13.6574 4.83688L9.66296 7.86525L11.1145 12.6631L7 9.8L2.8855 12.6631L4.33704 7.86525L0.342604 4.83688L5.3542 4.73475L7 0Z";

  const pathEmpty = document.getElementById("star-default--empty");
  const pathFilled = document.getElementById("star-default--filled");

  if (pathEmpty) pathEmpty.setAttribute("d", newPath);
  if (pathFilled) pathFilled.setAttribute("d", newPath);
}


function insertChannels() {
  const target = document.querySelector('.footer__item--social-media');
  if (!target) return;
  if (target.dataset.moreChannelsAdded) return;

  const lang = document.documentElement.lang || "";
  const title = lang.toLowerCase().startsWith("th") ? "ช่องทางเพิ่มเติม" : "More Channels";

  target.insertAdjacentHTML('beforeend', `
  <p class="footer__item-title heading heading--small">${title}</p>
  <div class="footer__item-content"><ul class="social-media  list--unstyled" role="list">
      <li class="social-media__item">
        <a href="https://shopee.co.th/aiiz_officialstore" target="_blank" rel="noopener" class="social-media__link">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="21" viewBox="0 0 18 21" fill="none">
            <path d="M0.88278 5.63937H4.97795C5.10304 4.25531 5.48917 3.01237 6.0439 2.05167C6.77809 0.781587 7.82228 0 9.00243 0C10.1826 0 11.2213 0.787015 11.961 2.05167C12.5157 3.00694 12.9018 4.25531 13.0269 5.63937H17.1166C17.6007 5.63937 18.0357 6.03559 17.9977 6.51865L17.1765 17.9548C17.0731 19.3877 16.1703 20.2073 14.8597 20.2073H3.14519C1.68767 20.2073 0.91541 19.1923 0.828395 17.9548L0.00174588 6.52408C-0.030885 6.04102 0.398755 5.63937 0.88278 5.63937ZM6.00039 5.63937H11.9936C11.8739 4.43985 11.5422 3.37602 11.0691 2.56187C10.5252 1.61202 9.78557 1.02041 9.00243 1.02041C8.21929 1.02041 7.47966 1.61202 6.92493 2.5673C6.45178 3.37602 6.12547 4.44528 6.00039 5.63937Z" fill="white"/>
            <path d="M6.02755 16.1962C5.8372 16.0659 5.78826 15.8108 5.91878 15.6209C6.04931 15.4309 6.30491 15.3821 6.49526 15.5123C6.61491 15.5937 6.73999 15.6752 6.87595 15.7566C7.83313 16.3373 8.71416 16.625 9.44835 16.625C10.1118 16.625 10.6503 16.3753 10.9929 15.8705C11.0146 15.8326 11.0364 15.8108 11.0418 15.7946C11.1397 15.6372 11.2104 15.4689 11.2594 15.3061C11.3573 14.9696 11.3409 14.6222 11.205 14.3074C11.0581 13.9763 10.7753 13.6561 10.3348 13.3901C10.0411 13.211 9.67677 13.0536 9.23625 12.9342C8.11593 12.6194 7.28928 12.1743 6.84332 11.5772C6.35386 10.9205 6.31579 10.1281 6.83789 9.16736C7.18595 8.53232 7.89839 8.1361 8.80118 8.06554C9.57888 8.00583 10.5143 8.19037 11.466 8.67344C11.6727 8.77656 11.7543 9.02624 11.6455 9.23249C11.5367 9.43874 11.292 9.52016 11.0853 9.4116C10.275 8.9991 9.50274 8.8417 8.861 8.89054C8.24645 8.93939 7.77874 9.17821 7.57208 9.55815C7.22402 10.1932 7.22946 10.6925 7.51226 11.0725C7.83856 11.5121 8.51838 11.8541 9.46467 12.12C9.97589 12.2666 10.411 12.4511 10.7699 12.6682C11.3627 13.0264 11.7597 13.4769 11.9718 13.9654C12.1893 14.4702 12.2165 15.0021 12.0697 15.5232C12.0044 15.7566 11.9011 15.99 11.7597 16.2179C11.7271 16.2668 11.7053 16.3048 11.689 16.3319C11.1832 17.0755 10.4055 17.4446 9.45923 17.45C8.57276 17.45 7.53945 17.1243 6.45175 16.4622C6.31579 16.3862 6.17439 16.2993 6.02755 16.1962Z" fill="black"/>
          </svg>
        </a>
      </li>
      <li class="social-media__item">
        <a href="https://www.lazada.co.th/shop/aiiz-officialstore" target="_blank" rel="noopener" class="social-media__link">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="19" viewBox="0 0 24 19" fill="none">
            <path d="M11.7548 18.6947C11.5918 18.6959 11.4307 18.6542 11.2885 18.5732C10.0723 17.8684 1.06163 12.2124 0.721567 12.04C0.462388 11.9192 0.285925 11.6714 0.255289 11.3867V3.45369C0.248549 3.15739 0.394989 2.87889 0.641914 2.71633L0.707475 2.67891C1.57937 2.13724 4.49775 0.35457 4.95913 0.0981509C5.06513 0.0349663 5.18583 0.00122689 5.30899 0C5.42418 0.00122689 5.53814 0.0300587 5.63986 0.0840417C5.63986 0.0840417 9.72301 2.74884 10.3474 2.98685C10.7855 3.18868 11.2634 3.28867 11.7456 3.28069C12.2921 3.29235 12.8319 3.16046 13.3117 2.89791C13.9226 2.57585 17.8238 0.0981509 17.8654 0.0981509C17.9641 0.0386469 18.0768 0.00797476 18.192 0.00920165C18.3152 0.00920165 18.4359 0.0435545 18.5419 0.107353C19.0731 0.401192 22.6906 2.61818 22.8444 2.71633C23.0986 2.86969 23.2531 3.14696 23.25 3.44448V11.3781C23.2212 11.6634 23.0441 11.9118 22.7837 12.0315C22.4437 12.2179 13.4612 17.8745 12.2217 18.5646C12.0807 18.6487 11.9196 18.6935 11.7554 18.6953" fill="white"/>
            <path d="M11.708 18.695H11.7546C11.9182 18.6962 12.0787 18.6545 12.2209 18.5735C13.4377 17.8687 22.4428 12.2127 22.7829 12.0403C23.0433 11.9207 23.2204 11.6723 23.2492 11.387V3.45398C23.251 3.31963 23.2204 3.18713 23.1603 3.06689L11.708 9.36205V18.6956" fill="white"/>
            <path d="M11.708 18.695H11.7546C11.9182 18.6962 12.0787 18.6545 12.2209 18.5735C13.4377 17.8687 22.4428 12.2127 22.7829 12.0403C23.0433 11.9207 23.2204 11.6723 23.2492 11.387V3.45398C23.251 3.31963 23.2204 3.18713 23.1603 3.06689L11.708 9.36205V18.6956" stroke="black" stroke-width="0.5"/>
            <path d="M11.668 18.5831H11.6221C11.4603 18.5843 11.3016 18.5426 11.1607 18.4628C9.95733 17.7653 1.04779 12.1701 0.7108 11.999C0.454071 11.8812 0.278221 11.6352 0.250036 11.353V3.50401C0.248811 3.37089 0.278834 3.23961 0.337655 3.12061L11.668 9.34889V18.5831Z" fill="white" stroke="black" stroke-width="0.5"/>
          </svg>
        </a>
      </li>
      <li class="social-media__item">
        <a href="https://www.tiktok.com/@aiiz" target="_blank" rel="noopener" class="social-media__link">
          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
            <path d="M17.2526 7.55605C17.1005 7.57401 16.9476 7.58482 16.7945 7.58859C15.1147 7.62284 13.5309 6.80681 12.5824 5.41836L12.7375 13.0959C12.8008 16.2298 10.3148 18.8217 7.18479 18.8851C4.05475 18.9485 1.46606 16.4594 1.40274 13.3256C1.33942 10.1918 3.82543 7.59976 6.95547 7.53636C7.07383 7.53396 7.18961 7.54224 7.30611 7.54726L7.36261 10.3436C7.24598 10.3319 7.13133 10.313 7.01163 10.3154C5.41411 10.3478 4.14529 11.6707 4.17761 13.2702C4.20993 14.8697 5.53115 16.1401 7.12867 16.1077C8.72651 16.0753 10.112 14.7863 10.0796 13.1866L9.84409 0.146929L12.516 0.0928066C12.8164 2.48667 14.7863 4.32138 17.1925 4.44857L17.2553 7.55633" fill="white"/>
          </svg>
        </a>
      </li>
    </ul>
  </div>
  `);

  target.dataset.moreChannelsAdded = "1";
}

// App Return 
function customAppReturn() {
  const root = document.querySelector('#return-app-proxy-root .yn-rt-card-exchange-items');
  if (!root) return false;

  if (document.getElementById('pmn-exchange-message')) return true;

  const locale = document.documentElement.getAttribute('lang');
  if (locale === 'th') {
    root.insertAdjacentHTML(
      'afterend',
      '<div id="pmn-exchange-message" class="exchange-message pmn-using-js">ลูกค้าสามารถเปลี่ยนสินค้าเป็นสินค้ารุ่นอื่นที่มีราคาเท่ากันหรือสูงกว่า โดยชำระเงินส่วนต่างเพิ่มเติม (หากมี) ทั้งนี้ บริษัท AIIZ ขอสงวนสิทธิ์ไม่คืนเงินส่วนต่างในกรณีที่สินค้าที่เลือกเปลี่ยนมีราคาต่ำกว่า</div>'
    );
  } else {
    root.insertAdjacentHTML(
      'afterend',
      '<div id="pmn-exchange-message" class="exchange-message pmn-using-js">Customers may exchange products for items of equal or higher value, subject to payment of any applicable price difference. AIIZ reserves the right not to refund any price difference if the replacement product is of lower value.</div>'
    );
  }

  return true;
}
document.addEventListener('DOMContentLoaded', function () {
  let done = customAppReturn();
  if (done) return;

  const observer = new MutationObserver(() => {
    done = customAppReturn();
    if (done) observer.disconnect();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
});


// Single Product
const blocks = document.querySelectorAll(
  '.shopify-section.shopify-section--main-product .product > .product__info .product-form > .shopify-block'
);
function checkBlock(el) {
  const c = el.cloneNode(true);
  c.querySelectorAll('script,style,link').forEach(n => n.remove());
  const text = (c.textContent || '').replace(/[\s\u00A0]+/g, '');
  el.classList.toggle('block--empty', text.length === 0);
}
function debounce(fn, delay) {
  let t;
  return function(...args) {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), delay);
  };
}
blocks.forEach(function(el) {
  checkBlock(el);

  const debouncedCheck = debounce(() => checkBlock(el), 100);

  const observer = new MutationObserver(debouncedCheck);
  observer.observe(el, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: false,
  });
});


// hide section when sub collection empty
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".shopify-section .swiper-wrapper").forEach(wrapper => {
    if (!wrapper.querySelector(".swiper-slide")) {
      wrapper.closest(".shopify-section").style.display = "none";
    }
  });
});


// prevent predictive search drawer for thai language because predictive search does not support Thai
/*
document.addEventListener('click', function(e) {
  const locale = document.documentElement.getAttribute('lang');
  if(locale !== 'th') return;

  const searchIcon = e.target.closest('a[aria-controls="search-drawer"]');
  if(!searchIcon) return;

  e.preventDefault();
  e.stopImmediatePropagation(); 
  window.location.href = `/${locale}/search`;
}, true);
*/

//prevent predictive search drawer for all language 
document.addEventListener('click', function(e) {
  const locale = Shopify?.locale || 'en';
  const defaultLocale = 'en';

  const searchIcon = e.target.closest('a[aria-controls="search-drawer"]');
  if(!searchIcon) return;

  e.preventDefault();
  e.stopImmediatePropagation(); 
  
  const path = (locale === defaultLocale) ? `/search` : `/${locale}/search`;
  window.location.href = path;
}, true);
